/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Enable_HelpInputs */

const en_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable or disable foot pedal control.`)
};

const fr_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer ou désactiver le contrôle par pédale.`)
};

const de_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fußpedalsteuerung aktivieren oder deaktivieren.`)
};

const it_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita o disabilita il controllo tramite pedale.`)
};

const ru_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включение или отключение управления с помощью ножной педали.`)
};

const es_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar o deshabilitar el control del pedal.`)
};

const zh_cn2_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用或禁用脚踏板控制。`)
};

const ja_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フットペダルコントロールを有効または無効にします。`)
};

const hi_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फुट पेडल कंट्रोल को चालू या बंद करें।`)
};

const pt_pt2_options_pedal_enable_help = /** @type {(inputs: Options_Pedal_Enable_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar ou desativar o controle por pedal.`)
};

/**
* | output |
* | --- |
* | "Enable or disable foot pedal control." |
*
* @param {Options_Pedal_Enable_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_enable_help = /** @type {((inputs?: Options_Pedal_Enable_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Enable_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_enable_help(inputs)
	if (locale === "de") return de_options_pedal_enable_help(inputs)
	if (locale === "it") return it_options_pedal_enable_help(inputs)
	if (locale === "ru") return ru_options_pedal_enable_help(inputs)
	if (locale === "es") return es_options_pedal_enable_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_enable_help(inputs)
	if (locale === "ja") return ja_options_pedal_enable_help(inputs)
	if (locale === "hi") return hi_options_pedal_enable_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_enable_help(inputs)
	return en_options_pedal_enable_help(inputs)
});